import { forwardRef } from 'react';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                d='M22.2505 9H19.1997C19.2131 9.95874 19.0349 10.9106 18.6754 11.8002C18.3159 12.6898 17.7822 13.4995 17.1055 14.1822C16.4287 14.8649 15.6223 15.407 14.7332 15.777C13.844 16.1471 12.8898 16.3376 11.926 16.3376C10.9622 16.3376 10.008 16.1471 9.11881 15.777C8.22965 15.407 7.42326 14.8649 6.7465 14.1822C6.06975 13.4995 5.5361 12.6898 5.17659 11.8002C4.81707 10.9106 4.63884 9.95874 4.65226 9H0V9.07994C0.00454471 11.6822 0.863474 14.2118 2.44609 16.2837C4.02871 18.3556 6.24837 19.8565 8.76732 20.558C11.2863 21.2595 13.9666 21.1231 16.4005 20.1697C18.8344 19.2162 20.8886 17.4979 22.2505 15.2761C22.2617 15.2593 22.2716 15.2411 22.2815 15.2243C23.4066 13.3703 24.0009 11.2456 24 9.07994V9.00701L22.2505 9Z'
                fill='#6347FF'
            />
            <path
                d='M12.0346 9L12.0929 8.96538H18.9993C19.0122 8.05528 18.8407 7.15172 18.4948 6.30722C18.1488 5.46272 17.6353 4.6941 16.9841 4.04603C16.3329 3.39796 15.5569 2.88336 14.7013 2.53212C13.8457 2.18087 12.9275 2 12 2C11.0725 2 10.1543 2.18087 9.29872 2.53212C8.44311 2.88336 7.66715 3.39796 7.01592 4.04603C6.36469 4.6941 5.85118 5.46272 5.50523 6.30722C5.15927 7.15172 4.98777 8.05528 5.00068 8.96538H11.9763L12.0346 9Z'
                fill='#6347FF'
            />
        </SvgIcon>
    );
});
